var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"checkbox"},[_c('label',[_c('input',{staticClass:"checkbox-input",attrs:{"type":"checkbox","disabled":_vm.disabled},domProps:{"checked":_vm.checked},on:{"change":function($event){return _vm.change($event)}}}),_c('span',{staticClass:"checkbox-style"})])])
}
var staticRenderFns = []

export { render, staticRenderFns }